import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const notification = {
  namespaced: true,
  state: {
    active: false,
    options: {},
    items: { 1: [], 2: [] },
    itemsAll: { 1: [], 2: [] },
    quantityNotification: 0
  },
  getters,
  mutations,
  actions
};
